import React, {Component} from 'react';

class VariantSelector extends Component {
  render() {
    return (
      <select
        className="Product__option"
        name={this.props.option.name}
        key={this.props.option.id + this.props.option.name + window.location.pathname}
        onChange={this.props.handleOptionChange}
      >
        {this.props.option.values.map((value) => {
          const isSoldout = !this.props.availableVariants.includes(value)
          const text = isSoldout ? `${value}-soldout` : value
          return (
            <option value={value} selected={value === this.props.selected} disabled={isSoldout} key={`${this.props.option.name}-${value}`}>{`${text}`}</option>
          )
        })}
      </select>
    );
  }
}

export default VariantSelector;



// WEBPACK FOOTER //
// ./routes/shop/components/VariantSelector.js